(function () {
	const initCollapsibleContent = () => {
		$(".collapsible-content__toggle").unbind("click").on("click", function (e) {
			const parent = $(this).parent();
			const parentContent = e.target.closest('.yg-collapsible-content__items');
			
			if(parentContent) {
				const items = parentContent.querySelectorAll('.collapsible-content__toggle');
				let index = 0;
				for(let i = 0; i < items.length; i++) {
					if(items[i] === e.target) {
						index = i;
						break;
					}
				}
				
				let topPosition = index * items[0].offsetHeight;
				
				parentContent.scrollTo({
					top: topPosition,
					behavior: 'smooth'
				});
			}
			
			if (!parent.hasClass("active")) {
				parent
					.siblings(".collapsible-content__item.active")
					.removeClass("active");
				parent.addClass("active");
				$(this)
					.closest(".collapsible-content__items")
					.find(".collapsible-content__answer")
					.stop()
					.slideUp(300);
				$(this).next().stop().slideDown(300);
			} else {
				parent
					.siblings(".collapsible-content__item.active")
					.removeClass("active");
				parent
					.closest(".collapsible-content__items")
					.find(".collapsible-content__answer")
					.stop()
					.slideUp(300);
				parent.removeClass("active");
				$(this).next().stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
